import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ConfigDB {
    data = {
        settings: {
            "layout_type": "ltr",
            sidebar: {
                type: "default",
                body_type: "default"
            },
            sidebar_setting: "border-sidebar",
            sidebar_backround: "dark-sidebar"
        },
        color: {
            layout_version: null,
            color: null,
            primary_color: null,
            secondary_color: null,
            mix_layout: "default"
        },
        router_animation: "fadeIn",
        background: 'content/Images/background.jpg'
    }

    conventional = this.data;

    takaful = {
        settings: {
            layout_type: 'ltr',
            sidebar: {
                type: 'default',
                body_type: 'default'
            },
            sidebar_setting: 'iconcolor-sidebar',
            sidebar_backround: 'dark-sidebar'
        },
        color: {
            layout_version: '',
            color: 'color-2',
            primary_color: '#0288d1',
            secondary_color: '#26c6da',
            mix_layout: 'default'
        },
        router_animation: 'fadeIn',
        background: 'content/Images/takafulbackground.jpg'
    };

    ltic = {
        settings: {
            layout_type: 'ltr',
            sidebar: {
                type: 'default',
                body_type: 'default'
            },
            sidebar_setting: 'iconcolor-sidebar',
            sidebar_backround: 'dark-sidebar'
        },
        color: {
            layout_version: '',
            color: 'color-6',
            primary_color: '#1B4792',
            secondary_color: '#6EC1E4',
            mix_layout: 'default',
            menu_text_color:'#fff'
        },
        router_animation: 'fadeIn',
        background: 'content/Images/background.png'
    };

    qic = {
        settings: {
            layout_type: 'ltr',
            sidebar: {
                type: 'default',
                body_type: 'default'
            },
            sidebar_setting: 'iconcolor-sidebar',
            sidebar_backround: 'dark-sidebar'
        },
        color: {
            layout_version: '',
            color: 'color-6',
            primary_color: '#2b3648',
            secondary_color: '#78b5e2',
            mix_layout: 'default',
            menu_text_color: '#fff'
        },
        router_animation: 'fadeIn',
        background: 'content/Images/background.png'
    };

    constructor() {
        const browserWindow = window || {};
        const browserWindowEnv = browserWindow['__env'] || {};
        if (browserWindowEnv.hasOwnProperty('takaful') && window['__env']['takaful'] == "true") {
            this.data = this.takaful;
        }

        if (browserWindowEnv.hasOwnProperty('insuranceDxTheme') &&
            window['__env']['insuranceDxTheme'] == "LTIC") {
            this.data = this.ltic;
        } else if (browserWindowEnv.hasOwnProperty('insuranceDxTheme') &&
            window['__env']['insuranceDxTheme'] == "QIC") {
            this.data = this.qic;
        }
        

    }


}
